import React from 'react';
import { Activity, Dumbbell, Wind, Brain, Heart, Shield } from 'lucide-react';
export function AdultBenefits() {
  return <section className="py-24 bg-off-white" data-id="element-490">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-491">
        <div className="text-center max-w-3xl mx-auto mb-12" data-id="element-492">
          <h2 className="text-4xl md:text-5xl text-ink mb-6" data-id="element-493">
            Fitness, Stress Relief & Confidence
          </h2>
          <p className="text-lg text-gray-warm" data-id="element-494">
            Adult Taekwondo is a genuine alternative to boring gym routines.
            You're not just burning calories — you're learning a real skill
            while you train, which is why adults actually keep showing up.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-495">
          {[{
          icon: Activity,
          title: 'Cardio & Conditioning',
          desc: 'Drills, footwork, and pad work build endurance without the treadmill grind.'
        }, {
          icon: Dumbbell,
          title: 'Strength & Power',
          desc: 'Stance work, kicks, and forms develop functional strength and lean muscle.'
        }, {
          icon: Wind,
          title: 'Flexibility & Mobility',
          desc: 'Progressive stretching and kicking improve range of motion week by week.'
        }, {
          icon: Brain,
          title: 'Stress Relief',
          desc: 'A focused, structured hour where you leave work, screens, and worries at the door.'
        }, {
          icon: Heart,
          title: 'Self-Discipline & Focus',
          desc: 'Habits built on the mat — showing up, paying attention, finishing — carry into the rest of your life.'
        }, {
          icon: Shield,
          title: 'Self-Defense Foundations',
          desc: 'Practical, awareness-based self-defense as part of training — not the whole story.'
        }].map((b, i) => <div key={i} className="bg-paper border border-subtle-gray rounded-2xl p-6 flex flex-col gap-3" data-id="element-496">
              <div className="w-12 h-12 bg-storm-red/10 rounded-xl flex items-center justify-center text-storm-red" data-id="element-497">
                <b.icon className="w-6 h-6" data-id="element-498" />
              </div>
              <h3 className="text-lg text-ink leading-tight" data-id="element-499">{b.title}</h3>
              <p className="text-gray-warm text-sm leading-relaxed" data-id="element-500">{b.desc}</p>
            </div>)}
        </div>
      </div>
    </section>;
}